// Store Subordinate
const state = {
    subordinate: {
        'role': '',
        'office': '',
        'name': ''
    }
};

const mutations = {
    'SET_SUBORDINATE' (state, subordinate) {
        state.subordinate = subordinate;
    },
    'CLEAR_SUBORDINATE' (state) {
        state.subordinate = {
            'role': '',
            'office': '',
            'name': ''
        }
    }
};

const actions = {
    setSubordinate: ({commit}, subordinate) => {
        commit('SET_SUBORDINATE', subordinate);
    },
    clearSubordinate: ({commit}) => {
        commit('CLEAR_SUBORDINATE');
    }
};

const getters = {
    subordinate: state => {
        return state.subordinate;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/subordinate.js